import React, {createContext, useState} from "react";


export const NotificatorContext = createContext()


export const Notificator = ({children}) => {
    const [visible, setVisible] = useState(false)
    const [text, setText] = useState('test text')

    const showNotification = (text) => {
        setText(text)
        setVisible(true)
        setTimeout(() => {
            setVisible(false)
            setTimeout(() => setText(''), 1000)
        }, 2000)
    }


    return (
        <NotificatorContext.Provider value={{showNotification}}>
            {children}
            <div className={'notificator' + (visible ? '' : ' hidden')}>
                <h5>{text}</h5>
            </div>
        </NotificatorContext.Provider>
    )
}